<template>
  <Dialog header="" v-model:visible="displayModal" :style="{ width: '35vw' }" :modal="true" @after-hide=""
    :closable="false" :breakpoints="{
      '1980px': '35vw',
      '1440px': '30vw',
      '960px': '70vw',
      '640px': '90vw',
    }">
    <template #header>
      <b-container fluid>
        <b-row>
          <b-col>
            <h6 class="compo-heading">{{ $t("Request.request") }}</h6>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <i class="pi pi-times" @click="backtopage()"></i>
          </b-col>
        </b-row>
      </b-container>
    </template>
    <b-form @submit.prevent="closeRequestModel">
      <div class="location-popup-line">
        <b-row class="pb-5 position-relative ms-1">
          <b-col class="pb-5 field">
            <img class="location-popup-icon1" src="../../../../../assets/Img/icons/location.svg" />

            <!-- <p class="light-txt ps-4">From Store</p> -->
            <div class="w-75">
              <!-- <CustomDropDown class="storename" v-model="storeData.fromStore"
                                    :items="storeData.fromOption" @update:modelValue="LoadToStore"
                                    :rules="{ required: true }" label="From Store" name="From Store" id="From Store"
                                    :required-icon="true" /> -->
              <!-- {{ RequestData.fromStore }}x -->

              <StoreDropDown :label="$t('Request.fromstore')" v-model="storeForm.FromStoreBrMapId" name="FromStore"
                id="FromStore" @update="Onchange($event)" disabled :rules="{ required: true }" :required-icon="true"
                :tostorefilter="1" />
              <!-- <StoreDropDown :label="$t('Request.fromstore')" v-model="RequestData.fromStore" name="FromStore"
                id="FromStore" @update:modelValue="Onchange($event)" disabled :rules="{ required: true }"
                :required-icon="true" /> -->
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="position-relative ms-1">
        <b-col class="field">
          <img class="location-popup-icon2" src="../../../../../assets/Img/icons/location.svg" />
          <!-- <p class="light-txt ps-4">To Store</p> -->
          <div class="w-75 locationpopupposition">
            <!-- {{ RequestData.toStore }}c -->
            <!-- {{ passStatus() }} -->
            <!-- {{ RequestData.fromStore }}
            {{ storeForm.ToStoreBrMapId }} -->
            <StoreDropDown class="storename" v-model="storeForm.ToStoreBrMapId" :storetype="passStatus()"
              :filterId="RequestData.fromStore" :rules="{ required: true }" :label="$t('Request.tostore')"
              :showClear="true" name="To Store" id="To Store" :required-icon="true"
              @update:modelValue="Onchange2($event)" @StoreOptions="StoreOptionsFun" />
            <!-- <CustomDropDown class="storename" v-model="RequestData.toStore" :items="RequestData.toOption"
              @update:modelValue="Onchange" :rules="{ required: true }" :label="$t('Request.tostore')" name="To Store"
              id="To Store" :required-icon="true" /> -->
          </div>
        </b-col>
      </b-row>
      <b-row class="border-top">
        <b-col class="pt-3 field d-flex flex-row-reverse mb-0">
          <AddButton class="" btnname="Next" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </Dialog>
</template>
<script lang="ts">
import { defineComponent, ref, reactive, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";

import AddButton from "../../../../../components/GeneralButtons/AddButton.vue";
import commonservice from "../../../Service/StoreService";
import CustomDropDown from "../../../../../components/FormComponents/Dropdown.vue";

import { DropdownChangeEvent } from "primevue/dropdown";
import { usePrimeVue } from "primevue/config";
import { OptionHTMLAttributes } from "vue";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";

import StoreDropDown from "../../../../../modules/Inventory/components/DropDown/StoreDropDown.vue";
import { setupHistoryManagement } from "../../../../../modules/Inventory/Service/HistoryManage";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    CustomDropDown,
    StoreDropDown,
  },
  props: {
    displayModal: {
      type: Boolean,
      default: true,
    },
    showone: {
      type: String,
      default: "",
    },
    value: {},
    StoreDetailsData: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    /*declaration Starts*/
    const displayModal = ref(true);
    const toast = useToast();
    const router = useRouter();
    const QueryStringValue = useRoute();

    let session: any = localStorage.getItem("UsersData");
    session = JSON.parse(session);

    const StoreDetailsData = reactive({
      StoreId: 0,
    });

    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    const RequestData = reactive({
      fromStore: ref(),
      fromOption: [],
      toStore: ref(),
      toOption: [],
      toStoreName: "",
      fromstorecode: "",
      tostorecode: "",
    });

    const storeForm = reactive({
      FromStore: 0,
      FromStoreName: "",
      ToStore: 0,
      ToStoreName: "",
      FromStoreCode: "",
      ToStoreCode: "",
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
    });

    onMounted(() => {
      let SessionUserData = localStorage.getItem("UsersData");
      if (SessionUserData !== null) {
        usersData = JSON.parse(SessionUserData);
      }

      Object.assign(storeForm, props.StoreDetailsData);
      LoadFromStore();
    });

    const { handleSubmit, errors, resetForm, resetField } = useForm();
    let sessionData: any = localStorage.getItem("sessionData");

    function update() {
      debugger;
      emit("update:modelValue", storeForm);
    }

    async function LoadFromStore() {
      try {
        // const result = await commonservice.getStoreListByUserId(
        //   usersData.UserId,
        //   usersData.OrganizationId,
        //   usersData.Admin,
        //   usersData.BranchId
        // );

        const result = await commonservice.StoreDropDownListByUserId(
          usersData.UserId,
          usersData.OrganizationId,
          usersData.Admin,
          usersData.BranchId
        );

        console.log(result);
        RequestData.fromOption = result["result"].map((item) => {
          item.name = item.Name;
          item.value = item.Id;
          return item;
        });

        let id: any = Number(QueryStringValue.query.storebranchmapid);

        storeForm.FromStoreBrMapId = id;

        // Find the store from options to get the store ID
        const fromStoreOption = result["result"].find(
          (item) => item.StoreBranchMapId === id
        );
        if (fromStoreOption) {
          RequestData.fromStore = fromStoreOption.Id;
        }

        if (QueryStringValue.query.status == "1") {
          LoadAllMainStore(RequestData.fromStore);
        } else {
          LoadToStore(RequestData.fromStore);
        }
      } catch (error) { }
    }

    //To Store Load
    async function LoadToStore(data) {
      debugger;
      if (data) {
        let options: any = RequestData.fromOption.find(
          (item) => item["value"] == data
        );

        if (options) {
          storeForm.FromStore = data;
          storeForm.FromStoreName = options["Name"];
          storeForm.FromStoreCode = options["Code"];
          storeForm.FromStoreBrMapId = options["StoreBranchMapId"];
          storeForm.FromStoreBranchId = options["BranchId"];

          update();

          try {
            const result = await commonservice.getStoreByStoreId(
              storeForm.FromStore,
              usersData.OrganizationId,
              usersData.BranchId
              // storeForm.FromStoreBranchId
            );

            console.log(result);
          } catch (error) { }
          // Set RequestData.fromStore for the StoreDropDown component
          RequestData.fromStore = data;

          update();

          // try {
          // const result = await commonservice.getStoreByStoreId(
          //   storeForm.FromStore,
          //   usersData.OrganizationId,
          //   usersData.BranchId
          // );

          // console.log(result);

          // } catch (error) {
          //   console.error("Error loading to store:", error);
          // }
        } else {
          console.error("From store option not found for ID:", data);
        }
      }
    }

    async function LoadAllMainStore(data) {
      debugger;
      if (data) {
        let options: any = RequestData.fromOption.find(
          (item) => item["value"] == data
        );

        storeForm.FromStore = data;

        storeForm.FromStoreName = options["Name"];
        storeForm.FromStoreCode = options["Code"];
        storeForm.FromStoreBrMapId = options["StoreBranchMapId"];
        storeForm.FromStoreBranchId = options["BranchId"];
        storeForm.StoreBrMapId = options["StoreBranchMapId"];

        try {
          // const result = await commonservice.getStoreListByUserId(
          //   usersData.UserId,
          //   usersData.OrganizationId,
          //   usersData.Admin,
          //   usersData.BranchId
          // );
          const result = await commonservice.StoreDropDownListByUserId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            usersData.BranchId
          );
          console.log(result);
          RequestData.toOption = result["result"]
            .filter(
              (item) =>
                item.HospitalId == session.OrganizationId &&
                item.StoreTypeId == 1 &&
                item.Id != storeForm.FromStore
            )
            .map((item) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            });
        } catch (error) { }
      }
    }

    //To store change
    function Onchange(data: any) {
      debugger;
      if (data) {
        RequestData.fromStore = data["Id"];
        storeForm.FromStoreName = data["Name"];
        storeForm.FromStoreCode = data["Code"];
        storeForm.FromStoreBrMapId = data["StoreBranchMapId"];

        storeForm.StoreBrMapId = data["StoreBranchMapId"];

        storeForm.FromStoreBranchId = data["BranchId"];

        storeForm.StoreBrMapId = data["StoreBranchMapId"];
      }
      update();
    }

    function Onchange2(data: any) {
      debugger;
      if (data!) {
        storeForm.ToStoreName = data!["Name"];
        storeForm.ToStoreCode = data!["Code"];

        storeForm.ToStore =
          data.StoreBranchMapId !== undefined ? data.StoreBranchMapId : data;
        storeForm.ToStoreBranchId = data["BranchId"];
      }
      update();
      if (data) {
        storeForm.ToStoreName = data["Name"];
        storeForm.ToStoreCode = data["Code"];
        // storeForm.ToStoreBrMapId = data["StoreBranchMapId"];
        storeForm.ToStore = data["Id"];
        storeForm.ToStoreBranchId = data["BranchId"];
      }

      update();
    }

    let StoreArray: any = ref([]);
    const StoreOptionsFun = (data) => {
      debugger;
      StoreArray.value = data;
      if (StoreArray.value.length == 1) {
        storeForm.ToStoreBrMapId = StoreArray.value[0];
        Onchange2(StoreArray.value[0]);
      }
    };

    //Popup close
    const closeRequestModel = handleSubmit((values) => {
      debugger;
      console.log(storeForm);

      if (storeForm.ToStoreBrMapId) {
        update();

        emit("storeUpdate", storeForm);
        displayModal.value = false;
      } else {
        toast.add({
          severity: "warn",
          summary: "To Store is Required",
          detail: "Choose To Store",
          life: 3000,
        });
      }
    });

    function passStatus() {
      if (QueryStringValue.query.status == "1") {
        return 7;
      } else if (QueryStringValue.query.status == "2") {
        return 8;
      } else if (QueryStringValue.query.status == "3") {
        return 9;
      }
    }

    function backtopage() {
      setupHistoryManagement(router, 2);
    }

    return {
      backtopage,
      passStatus,
      // QueryStringValue
      closeRequestModel,
      displayModal,
      RequestData,
      LoadToStore,
      storeForm,
      Onchange,
      Onchange2,
      StoreOptionsFun,
    };
  },
});
</script>

<style>
.location-popup-line {
  border-left: dashed #e1e1e1;
}

.locationpopupposition {
  margin-left: 3px;
}

.location-popup-icon1 {
  width: 25px;
  height: 25px;
  position: absolute;
  left: -15px;
}

.location-popup-icon2 {
  width: 25px;
  height: 25px;
  position: absolute;
  left: -11px;
  bottom: 72%;
}

.storename {
  margin-left: 100px;
}
</style>
